/** The colour theme: the device's ('system'), or a forced light or dark (<html data-theme>, st8n-tokens.css). */
export type Theme = 'system' | 'light' | 'dark';
// --bg in st8n-tokens.css, the same two colours as index.html's theme-color tags.
const BAR = { light: '#f6f7f9', dark: '#0c0d10' };
export function applyTheme(t: Theme) {
  if (t === 'system') document.documentElement.removeAttribute('data-theme');
  else document.documentElement.setAttribute('data-theme', t);
  // The status bar (and an installed app's title bar) follows a forced theme, not only the device's.
  for (const m of document.querySelectorAll<HTMLMetaElement>('meta[name=theme-color]')) {
    const mode = /dark/.test(m.getAttribute('media') ?? '') ? 'dark' : 'light';
    m.content = BAR[t === 'system' ? mode : t];
  }
}
